/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { gql, useLazyQuery } from '@apollo/client';
import { Text, Tooltip } from '@chakra-ui/react';
import useStore from '../../../store';

const Q_CANDIDATE = gql`
	query get($id: String!) {
		getAgentTerminationRequestCandidateById(id: $id) {
			id
			agent {
				id
				code
				name
				latinName
				nationality
			}
		}
	}
`;

export default function EventLoggingCandidateTerminationRequest({ id = null }) {
	const { currentLang: lang } = useStore((state) => state.currentLang);
	const [getCandidate, { data }] = useLazyQuery(Q_CANDIDATE);

	useEffect(() => {
		if (id) {
			const variables = { id };
			getCandidate({ variables });
		}
	}, [id]);

	return (
		<>
			{data?.getAgentTerminationRequestCandidateById && (
				<Tooltip
					label={
						data?.getAgentTerminationRequestCandidateById?.agent?.nationality !== 'KH'
							? data?.getAgentTerminationRequestCandidateById?.agent?.latinName
							: lang === 'kh'
							? data?.getAgentTerminationRequestCandidateById?.agent?.name
							: data?.getAgentTerminationRequestCandidateById?.agent?.latinName
					}
				>
					<Text cursor="pointer" fontSize="sm" fontWeight="semibold" color="gray.500">
						{data?.getAgentTerminationRequestCandidateById?.agent?.code}
					</Text>
				</Tooltip>
			)}
		</>
	);
}
